import { useEffect, useRef } from "react";

// Radix keeps dialogs mounted (open/close only animates), so state from the previous open survives.
// Runs `reset` on each open transition. The latest closure is read from a ref so parent re-renders
// while the dialog is open don't re-fire the reset (which would discard in-progress input).
export function useResetOnOpen(open: boolean, reset: () => void) {
  const resetRef = useRef(reset);
  resetRef.current = reset;
  useEffect(() => {
    if (open) resetRef.current();
  }, [open]);
}
